export {stringifyPosition} from './lib/index.js'
